import { v4 as uuidv4 } from 'uuid';
import { ready } from '../helpers/jQueryReplacements';

/**
 * Maps the possible positions of pressrelease containers to the event to send to GTM
 */
const pressReleaseLocationToEventMapping = {
  '.js-pressrelease-sidebar-box': 'sidebar',
  '.js-pressrelease-footer-box': 'footer',
  '.js-pressrelease-feed': 'feed',
};

/**
 * Given a querySelector, find all containers that may match. They may
 * contain press releases.
 *
 * @param {DOMString} locationSelector A selector that will select press release
 * containers
 * @returns {Array[DOMElement]} An Array of elements that may contain press releases
 */
const findContainers = (locationSelector) => (
  document.querySelectorAll(locationSelector)
);

/**
 * Given a container of press releases, find the press releases within the container
 * @param {Array[DOMElement]} container the container of press releases
 * @returns {Array[DOMElement]} found press releases
 */
const findPressReleases = (container) => (
  container.querySelectorAll('.js-pressrelease')
);

/**
 * Given a DOMElement representing a press release, find the id from the
 * data- attribute, and send it to GTM along with the event name
 * @param {DOMElement} pressReleaseElement The press release to log as seen in GTM
 * @param {String} eventName The event to log in GTM based on the container location
 */
const sendPRGTMEvent = (pressReleaseElement, eventName) => {
  const url = pressReleaseElement.getAttribute('data-pressrelease-full-url');

  window.dataLayer.push({
    event: 'pressrelease_impression',
    pressrelease_location: eventName,
    pressrelease_url: url,
  });
};

const sendTextToSpeechEvent = () => {
  // Send a text to speech event to GTM
  window.dataLayer.push({
    event: 'text_to_speech_play',
  });
};

const $audioControlElement = $('.text-to-speech__controls');
const $textToSpeechButtonElement = $('.text-to-speech__button');
// Get the audio element that will be used to play the text to speech
const textToSpeechAudioControl = document.getElementsByClassName('js-text-to-speech');

const showAudioControls = () => {
  $textToSpeechButtonElement.css('display', 'none');
  $audioControlElement.css('display', 'unset');
  textToSpeechAudioControl[0].play();
};

// Create a unique page ID that will serve as the base for FB event IDs
const pageID = uuidv4();
let eventCounter = 0;

/**
 * Create a unique event ID that will be added to FB events so that
 * they can be deduplicated. Event IDs are comprised of a Page ID +
 * the cardinality of the event to be sent.
 */
const generateEventID = () => {
  eventCounter += 1;
  return `${pageID}-${eventCounter}`;
};

/**
 * Given a DOMElement representing a signup form, find the value
 * for the input email textbox so it can be added to the signup event.
 * @param {DOMElement} form The signup form containing an email value
 */
const getEmail = (form) => {
  // find the email value in the text box associated w/ the submitted form
  const email = $(form).find('.email').val();
  // return normalized email
  return email.trim().toLowerCase();
};

/**
 * Given a DOMElement representing a signup form, extract the email and
 * combine w/ the information --event ID & event name-- necessary to send
 * a Lead event to Facebook. Push it to the dataLayer so it can be used by GTM.
 * @param {DOMElement} form The signup form containing an email value
 */
const sendSignupData = (form) => {
  const signupData = {
    user_data: {
      email_address: getEmail(form),
    },
    event_id: generateEventID(),
    event: 'generate_lead',
  };
  window.dataLayer.push(signupData);
};

/**
 * On every page ready, push an event_id to the dataLayer that will be used for
 * Facebook's pageview event in GTM pixel & GA4 config tags. This event_id is
 * overwritten when sending new events ie. in sendSignupData().
 */
const pushPageviewEventID = () => {
  window.dataLayer.push({
    event_id: generateEventID(),
  });
};

// Get the signup form elements on any page
const signupForms = document.querySelectorAll('form.js-form-email-validate');

ready(() => {
  if (window.dataLayer) {
    // For Facebook conversions, all events need event IDs so they can be deduplicated
    // as they are being sent from both the browser pixel (in GTM) and here. On every page
    // we create and push a unique Event ID to the data layer.
    pushPageviewEventID();
    if (signupForms.length > 0) {
      signupForms.forEach((form) => {
        form.addEventListener('triggerSignupOnGTM', () => sendSignupData(form));
      });
    }

    Object.entries(pressReleaseLocationToEventMapping).forEach(
      ([locationSelector, eventName]) => {
        const containers = findContainers(locationSelector);
        containers.forEach((container) => {
          const pressReleases = findPressReleases(container);
          pressReleases.forEach((pressRelease) => sendPRGTMEvent(pressRelease, eventName));
        });
      },
    );
    // If the audio element exists, then add an event listener to it
    // and send the event to GTM when it is played
    if (textToSpeechAudioControl.length > 0) {
      textToSpeechAudioControl[0].onplay = () => sendTextToSpeechEvent();
    }
  }

  $textToSpeechButtonElement.click(() => showAudioControls());
});
